module.exports = __webpack_public_path__ + "img/h1.803c6723.png";